module.exports = __webpack_public_path__ + "img/6.7aec6c07.png";